import api from './api';
import {mapSickDayDto} from "../dto/SickDayDTO";

export const getSickEntries = async ({role, userId}) => {
    try {
        const res =
            (role === 'admin' || role === 'super_admin')
                ? await api.get('/SickDay')
                : await api.get(`/SickDay/user/${userId}`);
        return res.data.map(mapSickDayDto);
    } catch (err) {
        console.error("Error loading sick day:", err);
        throw err;
    }
};

export const createSickDay = async ({user_id, start_date, end_date, number_days}) => {
    try {
        const res = await api.post('/SickDay', {user_id, start_date, end_date, number_days});
        return res.data;
    } catch (err) {
        console.error("Error creating sick day:", err);
        throw err;
    }
}

export const updateSickDay = async (id, {user_id, start_date, end_date, number_days}) => {
    try {
        const res = await api.patch(`/SickDay/${id}`, {user_id, start_date, end_date, number_days});
        return res.data;
    } catch (err) {
        console.error("Error updating sick day:", err);
        throw err;
    }
}


export const deleteSickDay = async (id) => {
    try {
        const res = await api.delete(`/SickDay/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting sick day:", err);
        throw err;
    }
}
